module.exports = new __parcel__URL__("review.19aa6bbe.webp").toString();